import { render } from "./Results.vue?vue&type=template&id=b77e0ad6"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"
script.render = render

export default script